import React from 'react';

import './ButtonDelete.scss';

const ButtonDelete = props => (
  <button type="button" onClick={props.onClick} className={`button button--delete ${props.extraClass ? `${props.extraClass}` : ''}`}>{props.children}</button>
);

export default ButtonDelete;
